import './App.css';
import React, { useState } from 'react';
import Header from './Components/Header';
import LanguageSelection from './Components/LanguageSelection';
import ModeSelection from './Components/ModeSelection';
import RestoreWallet from './Components/RestoreWallet';
import WalletSelection from './Components/WalletCreation';

function App() {
  const [currentStep, setCurrentStep] = useState(1);

  return (
    <div>
      <Header />
      <main className='p-2'>
        {currentStep === 1 && <LanguageSelection setCurrentStep={setCurrentStep}/>}
        {currentStep === 2 && <ModeSelection setCurrentStep={setCurrentStep}/>}
        {currentStep === 3 && <WalletSelection setCurrentStep={setCurrentStep}/>}
        {currentStep === 4 && <RestoreWallet setCurrentStep={setCurrentStep}/>}
      </main>
    </div>
  );
}

export default App;
